import React from 'react';
import { Section } from './ui/Section';
import { XCircleIcon } from 'lucide-react';
export function PainSection() {
  return <Section className="bg-stone-100" data-id="element-137">
      <div className="text-center mb-12" data-id="element-138">
        <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-139">
          El problema real (no es la IA)
        </h2>
        <p className="text-xl text-stone-600 max-w-2xl mx-auto" data-id="element-140">
          ChatGPT no te falla porque sea malo. Te falla por una razón concreta.
        </p>
      </div>

      <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-stone-200" data-id="element-141">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-142">
          <div data-id="element-143">
            <p className="text-lg text-stone-700 mb-6 leading-relaxed" data-id="element-144">
              Tú piensas en tu negocio con miles de detalles. Pero le escribes
              una frase sin contexto… y esperas una respuesta con precisión.
            </p>
            <p className="text-lg text-stone-700 font-medium" data-id="element-145">
              Entonces pasa lo inevitable:
            </p>
            <ul className="mt-6 space-y-4" data-id="element-146">
              {['Te entrega generalidades vacías', 'Suena a robot corporativo', 'Inventa cosas que no son verdad', "Te hace perder más tiempo del que 'ahorra'"].map((item, i) => <li key={i} className="flex items-start" data-id="element-147">
                  <XCircleIcon className="h-6 w-6 text-red-400 mr-3 flex-shrink-0" data-id="element-148" />
                  <span className="text-stone-700" data-id="element-149">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="bg-stone-50 p-8 rounded-xl border border-stone-100" data-id="element-150">
            <p className="text-2xl font-serif italic text-stone-500 text-center mb-4" data-id="element-151">
              "Y tú cierras la app con esta sensación..."
            </p>
            <div className="bg-white p-6 rounded-lg shadow-sm border border-stone-200 text-center" data-id="element-152">
              <span className="text-3xl font-bold text-stone-900 block" data-id="element-153">
                "Estoy atrasado."
              </span>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}